import React from "react";
import SubModuleTag from "./SubModuleTag";

const ChildModuleCard = ({
  module,
  child,
  selectedBaseModule,
  toggleChildModule,
  toggleSubModule,
  toggleAllSubModules,
  type = "core",
}) => {
  const selectedChildModule =
    selectedBaseModule?.SUBSCRIBED_MODULE_DETAILS?.find(
      (item) => item.MODULE_ID === child.MODULE_ID,
    );

  const childSelected = !!selectedChildModule;

  // =========================
  // IMPORTANT
  // =========================
  // PRICE RULE:
  //
  // BASEMODULE price ALWAYS added
  //
  // MODULE price NOT added
  //
  // ONLY SUBMODULE price added
  // when selected
  // =========================

  const allSubsSelected =
    child.SUBMODULES_DATA?.length > 0 &&
    child.SUBMODULES_DATA.every((sub) =>
      selectedChildModule?.SUBSCRIBED_SUBMODULE_DETAILS?.some(
        (item) => item.SUBMODULE_ID === sub.SUBMODULE_ID,
      ),
    );

  const theme =
    type === "addon"
      ? {
          activeCard:
            "border-violet-300 dark:border-violet-500/40 bg-violet-50 dark:bg-violet-500/10",

          checkbox:
            "bg-violet-600 border-violet-600 dark:bg-violet-500 dark:border-violet-500",

          button:
            "text-violet-700 dark:text-violet-300 hover:bg-violet-100 dark:hover:bg-violet-500/10",

          section: "border-violet-100 dark:border-violet-500/10",
        }
      : {
          activeCard:
            "border-teal-300 dark:border-teal-500/40 bg-teal-50 dark:bg-teal-500/10",

          checkbox:
            "bg-teal-600 border-teal-600 dark:bg-teal-500 dark:border-teal-500",

          button:
            "text-teal-700 dark:text-teal-300 hover:bg-teal-100 dark:hover:bg-teal-500/10",

          section: "border-teal-100 dark:border-teal-500/10",
        };

  return (
    <div
      className={`
        rounded-2xl border overflow-hidden
        transition-all duration-300

        ${
          childSelected
            ? `${theme.activeCard} shadow-sm`
            : `
              border-slate-200 dark:border-slate-700
              bg-white dark:bg-slate-900
            `
        }
      `}
    >
      {/* HEADER */}

      <div
        onClick={() => toggleChildModule(module.BASEMODULE_ID, child)}
        className="
          flex items-center gap-3
          p-4 cursor-pointer
        "
      >
        <div
          className={`
            w-5 h-5 rounded-md border-2
            flex items-center justify-center

            ${
              childSelected
                ? theme.checkbox
                : `
                  border-slate-300
                  dark:border-slate-600
                `
            }
          `}
        >
          {childSelected && (
            <svg
              className="w-2.5 h-2.5 text-white"
              fill="none"
              viewBox="0 0 10 10"
            >
              <path
                d="M1.5 5l2.5 2.5 5-5"
                stroke="currentColor"
                strokeWidth="2"
              />
            </svg>
          )}
        </div>

        <div className="flex-1">
          <p className="text-sm font-semibold">{child.MODULE_NAME}</p>

          <p className="text-[11px] text-slate-500 mt-1">
            Module required for sub-modules
          </p>
        </div>

        {/* IMPORTANT */}
        {/* MODULE PRICE NOT COUNTED */}

        {/* <div className="text-right">
          <p className="text-sm font-bold text-slate-800 dark:text-white">$0</p>

          <p className="text-[10px] text-slate-500">module price ignored</p>
        </div> */}
      </div>

      {/* SUBMODULES */}

      {childSelected && child.SUBMODULES_DATA?.length > 0 && (
        <div
          className={`
              px-4 pb-4 pt-3
              border-t
              ${theme.section}
            `}
        >
          <div className="flex items-center justify-between mb-3">
            <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">
              Sub Modules
            </p>

            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();

                toggleAllSubModules(module.BASEMODULE_ID, child);
              }}
              className={`
                  text-[11px]
                  font-medium
                  px-3 py-1.5
                  rounded-lg
                  ${theme.button}
                `}
            >
              {allSubsSelected ? "Deselect all" : "Select all"}
            </button>
          </div>

          <div className="flex flex-wrap gap-2.5">
            {child.SUBMODULES_DATA.map((sub) => (
              <SubModuleTag
                key={sub.SUBMODULE_ID}
                module={module}
                child={child}
                sub={sub}
                selectedChildModule={selectedChildModule}
                toggleSubModule={toggleSubModule}
                type={type}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ChildModuleCard;
